import React from 'react'
import { NavLink } from 'react-router-dom'

import * as config from 'styles/tailwind.config'
import { isExternalUrl } from 'utils'

interface IProps {
  linkTo: string
  children: any
}

const NavItem: React.FC<IProps> = ({ linkTo, children }) => {
  const [isActive, setActive] = React.useState<boolean>(false)

  const handleActive = (match: any) => {
    if (!match || !match.isExact) {
      setActive(false)
      return false
    }
    setActive(true)
    return true
  }

  return (
    <li className="relative h-full flex items-center ml-30 first-child:ml-0">
      {isActive && <div className="absolute w-full h-3 bg-brand-primary" style={{ bottom: -1 }} />}
      {isExternalUrl(linkTo) ? (
        <a
          className="h-full flex items-center font-500 text-black text-10 tracking-1.5 uppercase"
          href={linkTo}
          target="_blank"
          rel="noopener noreferrer"
        >
          {children}
        </a>
      ) : (
        <NavLink
          activeStyle={{
            color: config.theme.colors.brand.primary,
          }}
          isActive={handleActive}
          className="h-full flex items-center font-500 text-black text-10 tracking-1.5 uppercase"
          to={linkTo}
        >
          {children}
        </NavLink>
      )}
    </li>
  )
}

export default NavItem
